<template>
  <v-autocomplete
    outlined
    hide-details
    clearable
    return-object
    no-filter
    hide-selected
    hide-no-data
    item-text="descricao"
    :single-line="singleLine"
    :label="label"
    v-model="localValue"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    @blur="onBlur"
    @focus="onFocus"
    v-bind="$attrs">
    <template v-slot:item="item">
      <v-list-item-content>
        <v-list-item-title>
          <px-chip-codigo-interno :codigo-interno="item.item.codigoInterno"/>
          {{ item.item.descricao }}
        </v-list-item-title>
      </v-list-item-content>
    </template>
    <template v-slot:selection="item">
      <div class="truncate-text">
        <px-chip-codigo-interno :codigo-interno="item.item.codigoInterno"/>
        {{ item.item.descricao }}
      </div>
    </template>
    <template v-slot:append-outer>
      <slot name="append-outer"/>
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from 'vuetify/lib/util/helpers';
import CadastrosAdicionaisService from '@/api/cadastros-adicionais-service';

const DEFAULT_LIMIT = 100;
const DEFAULT_OFFSET = 0;

export default {
  props: {
    value: Object,
    type: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: 'Cadastro adicional',
    },
    searchByStartOnly: {
      type: Boolean,
      default: false,
    },
    initSearch: {
      type: Boolean,
      default: false,
    },
    singleLine: {
      type: Boolean,
      default: true,
    },
    fetchOnFocus: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      items: [],
      model: null,
      search: null,
      debounceSearch: null,
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  watch: {
    search(val) {
      if (!val || (this.localValue && val === this.localValue.descricao)) return;
      this.debounceSearch(val);
    },
    value() {
      this.debounceSearch(null);
    },
  },
  methods: {
    buildStringSearchTerm(term, field) {
      if (this.searchByStartOnly) {
        return `${field} like "${term.toLowerCase()}%"`;
      }
      return `${field} like "%${term.toLowerCase()}%"`;
    },
    searchItems(val) {
      const searchValue = val || '';
      const searchTerm = searchValue.toLowerCase();

      const query = `(${this.buildStringSearchTerm(searchTerm, 'descricao')} or ${this.buildStringSearchTerm(searchTerm, 'codigoInterno')}) and tipo = "${this.type}" and ativo is true order by descricao`;
      this.loading = true;
      CadastrosAdicionaisService.getCadastrosAdicionais({
        limit: DEFAULT_LIMIT,
        offset: DEFAULT_OFFSET,
        query,
      })
        .then((response) => {
          if (this.value) {
            this.items = [this.value, ...response.data.content];
            return;
          }
          this.items = response.data.content;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
    onFocus() {
    },
    onClickReplicarCampo(campo) {
      this.$emit('replicar-campo', campo);
    },
  },
  created() {
    this.debounceSearch = debounce(this.searchItems, 1000);
    if (this.value) {
      this.items = [this.value];
    }
    if (this.initSearch) {
      this.debounceSearch();
    }
  },
};
</script>
